import React, { Component } from 'react';
import './../App.css';

class Footer extends Component {
  render() {
    return (
      <div className="App">
        <footer className="App-header">
          <h3 className="app-footer">site name copy-rights logo</h3>
        </footer>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js